var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXirifyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.465,
    height: 27.99,
    viewBox: "0 0 25.465 27.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32241",
    "data-name": "Group 32241",
    transform: "translate(0.65 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20613",
    "data-name": "Group 20613",
    transform: "translate(9.682 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M3154.963,466.537a2.822,2.822,0,0,1-2.085.911,2.771,2.771,0,0,1-2.023-.847l-8.72-8.693a2.9,2.9,0,0,1-.848-2.05,2.786,2.786,0,0,1,.848-2.023l8.693-8.529a2.861,2.861,0,1,1,4.019,4.073l-4.633,3.913a3.446,3.446,0,0,0-.011,5.255l4.661,3.971A2.893,2.893,0,0,1,3154.963,466.537Z",
    transform: "translate(-3141.287 -444.478)",
    fill: "#80808c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20614",
    "data-name": "Group 20614",
    transform: "translate(0 8.614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M3101.8,493.718l3.5-2.978a2.584,2.584,0,0,0-.009-3.942l-3.475-2.934a2.146,2.146,0,1,1,3.014-3.055l6.52,6.4a2.092,2.092,0,0,1,.635,1.517,2.173,2.173,0,0,1-.635,1.538l-6.541,6.52a2.077,2.077,0,0,1-1.517.636,2.118,2.118,0,0,1-1.564-.684A2.17,2.17,0,0,1,3101.8,493.718Z",
    transform: "translate(-3101.151 -480.189)",
    fill: "#80808c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20615",
    "data-name": "Group 20615",
    transform: "translate(8.533 23.545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M3139.971,543.808a1.723,1.723,0,1,1-1.723-1.723A1.723,1.723,0,0,1,3139.971,543.808Z",
    transform: "translate(-3136.525 -542.085)",
    fill: "#80808c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20616",
    "data-name": "Group 20616",
    transform: "translate(14.276 23.545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M3163.778,543.808a1.723,1.723,0,1,1-1.722-1.723A1.723,1.723,0,0,1,3163.778,543.808Z",
    transform: "translate(-3160.333 -542.085)",
    fill: "#80808c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXirifyIcon);
export default __webpack_public_path__ + "static/media/XirifyIcon.0b19a0cff298141db95927ce231c6b9a.svg";
export { ForwardRef as ReactComponent };